<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="1200"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-text v-if="providerSelected" class="pt-0 pb-0">
                    <template>
                        <v-row>
                            <v-col cols="6">
                                <span class="title">{{ providerSelected.name }}</span>
                                <span class="d-block">
                                    RUC
                                    {{ providerSelected.document }}
                                </span>
                            </v-col>
                            <v-col cols="6">
                                
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>                
            </v-card>

            <v-card class="mt-3">
                <v-data-table
                    class="wost-table"
                    :headers="headers"
                    :items="debtsProvider"
                    item-key="id"
                    height="65vh"
                    no-data-text=""
                    show-expand
                    fixed-header
                    :single-expand="true"
                >   
                    <template v-slot:item.serie="{ item }">
                        {{ item.purchase.serie }}-{{ item.purchase.correlative}}
                    </template>                           
                    <template v-slot:item.entry_date="{ item }">
                        {{ item.entry_date | moment("DD/MM/YYYY") }}
                    </template>
                    <template v-slot:item.date_agreement="{ item }">
                        {{ item.date_agreement | moment("DD/MM/YYYY") }}
                    </template>                                   
                    <template v-slot:item.amount="{ item }">
                        {{ item.amount | currency('S/ ') }}
                    </template>
                    <template v-slot:item.amount_paid="{ item }">
                        {{ item.amount_paid | currency('S/ ') }}
                    </template>
                    <template v-slot:item.amount_pending="{ item }">
                        {{ item.amount_pending | currency('S/ ') }}
                    </template>
                    <template v-slot:item.status="{ item }">
                        <span :class="[
                            'status-account',
                            'status-account-' + item.condition
                        ]">{{ item.condition }}</span>
                    </template>
                    <template v-slot:item.action="{ item }">
                        <v-btn small 
                            v-if="item.amount_pending > 0 && verifyPermission('amortizar_cuentas')" 
                            color="primary" 
                            @click="handlePayDebt(item)"> 
                            Amortizar
                        </v-btn>
                    </template>
                    <template v-slot:expanded-item="{ item, headers }">
                        <td :colspan="headers.length" class="wost-td-expanded">
                            <template>
                                <v-container>
                                    <v-row justify="center">
                                        <v-col cols="10" class="pt-0 pb-1">
                                            <span class="font-weight-medium caption">Detalle de amortizaciones</span>
                                        </v-col>
                                    </v-row>
                                    <v-row justify="center">
                                        <v-col cols="10" class="pt-0 pb-0">
                                            <v-simple-table dense>
                                                <thead>
                                                    <tr>
                                                        <th>Fecha y Hora de amortización</th>
                                                        <th>Monto Amortizado</th>
                                                        <th>Observaciones</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="payment in item.payments" :key="payment.id">
                                                        <td>{{ payment.payment_date  | moment("DD/MM/YYYY, h:mm a") }}</td>
                                                        <td>{{ payment.amount_payment | currency('S/') }}</td>
                                                        <td>{{ payment.description}}</td>
                                                    </tr>
                                                </tbody>
                                            </v-simple-table>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>                                            
                        </td>
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <pay-account ref="payAccount"></pay-account>
    </v-navigation-drawer>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

import PayAccount from './PayAccount'

export default {
    name: 'AccountDetail',
    components: {
        PayAccount
    },
    data() {
        return {
            titleForm: '',
            drawer: false,
            headers: [
                { text: '', value: 'data-table-expand', width: 5, class: 'header-table-expand' },
                { text: 'Comprobante', value: 'serie', align: 'left', sortable: false, class: 'header-table', width: 150},
                { text: 'Fecha Deuda', value: 'entry_date', align: 'left', sortable: false, class: 'header-table', width: 130},
                { text: 'Vencimiento', value: 'date_agreement', align: 'left', sortable: false, class: 'header-table', width: 100},      
                { text: 'Monto', value: 'amount', align: 'end', sortable: false, class: 'header-table', width: 130 },
                { text: 'Pagado', value: 'amount_paid', align: 'end', sortable: false, class: 'header-table', width: 130},
                { text: 'Pendiente', value: 'amount_pending', align: 'end', sortable: false, class: 'header-table', width: 130},
                { text: 'Estado', value: 'status', align: 'center', sortable: false, class: 'header-table', width: 100},
                { text: 'Acciones', value: 'action', sortable: false, class: 'header-table', width: 35 }
            ]
        }
    },
    computed: {
        ...mapState('provider', [
            'providerSelected',
            'debtsProvider'
        ]),
    },
    methods:{
        ...mapActions('provider', [
            'runSetSelectedDebt'
        ]),
        showForm(title) {
            this.titleForm = title
            this.drawer = !this.drawer
        },
        handlePayDebt(debt){
            this.runSetSelectedDebt(null)
            this.runSetSelectedDebt(debt)
            this.$refs.payAccount.showForm('Amortizar cuenta por Pagar')
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    }
}
</script>

<style scoped>
.status-account{
    display: block;
    padding-left: 3px;
    color: #ffffff;
    border-radius: 3px;
    font-size: 12px;
    width: 80px;
}

.status-account-pendiente{
    background-color: #FFB300;
}

.status-account-vencida{
    background-color: #E53935;
}

.status-account-pagada{
    background-color: #43A047;
}
</style>